<template>
  <div class="container-cuentaservicio full-height">
    <q-card class="my-card full-height">
      <q-card-section>
        <div class="row">
          <div class="col-12">
            <q-table
              title="Cuentas de servicio"
              data-cy="list-cuentas-de-servicio"
              row-key="id"
              flat
              :pagination.sync="pagination"
              :columns="columns"
              :data="cuentasServicio"
              :loading="isLoadingCuentaServicio"
            >
              <template v-slot:top-right>
                <div>
                  <q-btn
                    data-cy="new-cuentaservicio"
                    color="primary"
                    label="CREAR CUENTA DE SERVICIO"
                    icon="settings"
                    @click="triggerNew()"
                  />
                </div>
              </template>
              <template v-slot:body-cell-acciones="props">
                <q-td key="acciones" :props="props">
                  <q-icon
                  data-cy="edit-cuentaservicio"
                  name="o_create"
                  style="color: #002f6c; font-size: 24px; cursor: pointer;"
                  @click="triggerEdit(props.row)"
                />
                  <q-icon
                    name="o_delete"
                    style="color: #002f6c; font-size: 24px; cursor: pointer;"
                    @click="triggerDelete(props.row)"
                    data-cy="delete-cuentaservicio"
                  />
                </q-td>
              </template>
            </q-table>
          </div>
        </div>
      </q-card-section>
    </q-card>
    <CuentasServicioFormModal v-model="showModalNewCuentaServicio" :dependecyApp="dependecyApp" :cuentaServicioSelected="cuentaServicioSelected" />
    <DialogDelete
      v-if="cuentaServicioSelected"
      v-model="showModalDeleteCuentaServicio"
      :showIcon="true"
      :txtContainer="
        `¿Está seguro de eliminar la cuenta de servicio ${cuentaServicioSelected.name}?`
      "
      dataCy="confirm-delete-cuentaservicio"
      @save="deleteCuentaServicio()"
      :isLoading="isLoadingDelete"
    />
  </div>
</template>

<script>
import { QTable, QTd } from 'quasar';
import CuentasServicioFormModal from './CuentasServicioFormModal.vue';
import DialogDelete from '@/shared/dialogs/delete/DialogDelete.vue';
import Loading from '@/components/shared/mixins/Loading.js';
import Message from '@/components/shared/mixins/Message.js';

export default {
  components: {
    QTable,
    QTd,
    CuentasServicioFormModal,
    DialogDelete
  },
  props: {
    dependecyApp: {
      required: false,
      type: Object,
      default: () => {}
    }
  },
  mixins: [Loading, Message],
  data: function () {
    return {
      isLoadingCuentaServicio: false,
      cuentasServicio: [],
      pagination: {
        sortBy: 'name',
        descending: false,
        rowsPerPage: 20
      },
      columns: [
        {
          name: 'name',
          label: 'Cuentas de servicio',
          align: 'left',
          field: 'name',
          sortable: true
        },
        {
          name: 'acciones',
          label: 'Acciones',
          align: 'center',
          sortable: false
        }
      ],
      showModalNewCuentaServicio: false,
      showModalDeleteCuentaServicio: false,
      cuentaServicioSelected: {},
      isLoadingDelete: false
    };
  },
  mounted () {
    this.$eventHub.$on('refreshCuentasServicioList', async () => { this.loadCuentasServicio(); });
  },
  beforeDestroy () {
    this.$eventHub.$off('refreshCuentasServicioList');
  },
  methods: {
    async loadCuentasServicio () {
      this.showLoading();

      let request = {
        controller: `/Aplicacion/${this.dependecyApp.id}/CuentasServicio`
      };

      await this.$store
        .dispatch('PF/getSuit', request)
        .then(response => {
          this.cuentasServicio = response.data;
        })
        .catch(err => {
          this.showError(err.message);
        })
        .finally(() => {
          this.hideLoading();
        });
    },
    async loadCuentaServicio (id) {
      let cuentaServicio = {};
      this.showLoading();

      let request = {
        controller: `/CuentaServicio/${id}`
      };

      await this.$store
        .dispatch('PF/getSuit', request)
        .then(response => {
          cuentaServicio = response.data;
        })
        .catch(err => {
          this.showError(err.message);
        })
        .finally(() => {
          this.hideLoading();
        });
      return cuentaServicio;
    },
    triggerNew () {
      this.cuentaServicioSelected = {};
      this.showModalNewCuentaServicio = true;
    },
    async triggerEdit (row) {
      this.cuentaServicioSelected = await this.loadCuentaServicio(row.id);
      this.showModalNewCuentaServicio = true;
    },
    triggerDelete (row) {
      this.cuentaServicioSelected = row;
      this.showModalDeleteCuentaServicio = true;
    },
    async deleteCuentaServicio () {
      this.isLoadingDelete = true;
      this.showLoading();

      let request = {
        controller: `/CuentaServicio/${this.cuentaServicioSelected.id}`,
        filter: {}
      };

      await this.$store
        .dispatch('PF/deleteSuit', request)
        .then(async () => {
          await this.loadCuentasServicio();
          this.showMessage(`Cuenta de servicio ${this.cuentaServicioSelected.name} eliminada correctamente.`);
          this.showModalDeleteCuentaServicio = false;
          this.cuentaServicioSelected = {};
        })
        .catch(e => {
          this.showError(e.message);
        })
        .finally(() => {
          this.hideLoading();
          this.isLoadingDelete = false;
        });
    }
  },
  watch: {
    dependecyApp: {
      async handler () {
        await this.loadCuentasServicio();
      },
      deep: true
    }
  }
};
</script>

<style lang="scss" scoped>
.container-table-user {
  &:deep() {
    .q-table__card {
      box-shadow: none;
    }

    .q-card__section--vert {
      padding: 0 !important;
    }
  }
}
</style>
